export const RELOADED_BUILD_KEY = 'staleChunkReloadedBuild';

// The entry script's hashed URL changes whenever any chunk does
function currentBuild() {
  return (
    document.querySelector<HTMLScriptElement>('script[type="module"][src]')
      ?.src ?? ''
  );
}

/**
 * Each deploy deletes the previous build's chunks, so a tab still running the
 * old bundle 404s on its next lazy route. Reload once per build to pick up
 * the new one; if the reload lands on the same build, the chunk is genuinely
 * unreachable and reloading again would only loop.
 */
export function handlePreloadError(event: Event) {
  const build = currentBuild();

  try {
    if (sessionStorage.getItem(RELOADED_BUILD_KEY) === build) {
      return;
    }
    sessionStorage.setItem(RELOADED_BUILD_KEY, build);
  } catch {
    return;
  }

  event.preventDefault();
  window.location.reload();
}

export function init() {
  window.addEventListener('vite:preloadError', handlePreloadError);
}
